import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1400 30%, #0d0a00 60%, #0a0a0a 100%)'
  }} data-id="element-186">
      <div className="mb-4" data-id="element-187">
        <span className="text-[#FFD700] text-xl sm:text-2xl font-black tracking-widest" data-id="element-188">
          🎭 PROFEPACK®
        </span>
      </div>

      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-189">
        Todo tu año de Teatro
        <br data-id="element-190" />
        <span className="text-[#FFD700]" data-id="element-191">resuelto.</span>
      </h1>

      <div className="w-full max-w-[280px] sm:max-w-[360px] md:max-w-md mx-auto mb-4" style={{
      aspectRatio: '1080/900'
    }} data-id="element-192">
        <img src="https://cdn.magicpatterns.com/uploads/icNBkAJhjMvAfYLHKdV7yC/Diseno-sin-titulo-_21_.webp" alt="PROFEPACK® MegaPack Teatro Listo — Combo Completo" className="w-full h-full object-contain" width={1080} height={900} fetchPriority="high" data-id="element-193" />
      </div>

      <p className="text-[#FFD700] text-lg sm:text-2xl font-bold max-w-3xl mb-[0px]" data-id="element-194">
        "Listo para usar. Sin buscar más. Sin improvisar. Sin perder domingos."
      </p>

      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-195">
        El sistema para profesores de teatro en Argentina: año completo listo
        (clases + técnica + musicalidad + retención + corrección + negocio), sin
        buscar ni armar desde cero.
      </p>

      <div className="flex flex-nowrap mb-[10px] gap-1 sm:gap-[5px] items-center justify-center mx-auto px-1" data-id="element-196">
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-197">
          📄 PDF
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-198">
          ⚡ Inmediato
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-199">
          🇦🇷 Argentina
        </span>
        <span className="bg-black/50 border border-[#FFD700]/40 text-white text-[8px] sm:text-sm font-semibold px-1.5 sm:px-3 py-0.5 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-200">
          🎭 Todos los niveles
        </span>
      </div>

      <a href="#pricing" className="btn-green-pulse bg-[#FFD700] text-black font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#FFE44D] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm" data-id="element-201">
        🎭 → QUIERO MI PROFEPACK AHORA
      </a>

      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-202">
        <span data-id="element-203">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-204">🔒 Pago 100% seguro</span>
        <span data-id="element-205">💳 Mercado Pago | Tarjeta | Transferencia</span>
      </p>
    </section>;
}